jQuery(document).ready(function(){
    jQuery('#galleryblock').lightGallery({
        thumbnail: false,
    });
});